import React from 'react';
import './About.css';
import profilepic from "../Images/mypic.jpg";
import Fade from 'react-reveal/Fade';
import Flip from 'react-reveal/Flip';

const About = () => {
  return (
    <div className="container about-section" id="about">
      <div className="row">
      <Fade bottom >

      <div className="col-xl-6 col-lg-6 col-md-32 col-sm-12">
         <div className="about-image">
         <img src={profilepic} alt="profile pic"/>
         </div>
      </div>
      </Fade>
       
     
      <div className="col-xl-6 col-lg-6 col-md-32 col-sm-12">
      <div className="about-details">
      <Flip left>
      <div className="about-title">
      <h5>About Me</h5>
      <span className="line"></span>
      </div>
      </Flip>

      <Fade right>
      <p>
      Hi there! I'm Minoli, a 22-year-old,i am deeply passionate about React. I'm dedicated towards my work, and in my free time, you'll often find me searching new technologyy.I love reading books and dancing. This space is where I share my thoughts and experiences . Let's connect and explore our shared passions!
      </p>
      </Fade>
      </div>
      </div>  

</div>
    </div>
  );
};

export default About;

